import React, { useState, useEffect, useCallback } from "react";
//component
import Header from "../../../components/molecules/Header";
//utils
import {
  firefunctions,
  firestore,
} from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import { useHistory, useParams, useLocation } from "react-router";
import { useCollectionData } from "react-firebase-hooks/firestore";
import currency from "./../../../utils/currency";
import { date } from "../../../utils/dateTime";
//style
import useStyles from "./style";
//material
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

function PopupKonfirmasi({
  popupKonfirmasi,
  handleConfirm,
  loading,
  handleClose,
  data,
}) {
  return (
    <Dialog open={popupKonfirmasi} onClose={handleClose}>
      <DialogTitle>
        <Typography style={{ fontSize: 18 }}>Konfirmasi!</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography style={{ fontSize: 16 }}>
          Mohon dipastikan nominal {data?.title} sudah sesuai.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          // fullWidth
          variant="text"
          // color="secondary"
          disabled={loading}
          size="small"
          onClick={handleClose}
        >
          Batal
        </Button>
        <Button
          // fullWidth
          variant="text"
          // color="primary"
          size="small"
          onClick={handleConfirm}
          disabled={loading}
        >
          Lanjutkan
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DialogAlert({ open, handleClose, data }) {
  let isTitle = data?.status
    ? `alhamdulillah kamu sudah ikut berkontribusi lebih dalam langkah kemanusiaan pada program ${
        data?.data?.nama ?? ""
      }`
    : "Mohon maaf sepertinya ada kendala mohon coba ulangi donasi";

  let isIcon = data?.status ? (
    <CheckCircleIcon style={{ color: "#27AE60", fontSize: "3rem" }} />
  ) : (
    <CancelIcon color="error" style={{ fontSize: "3rem" }} />
  );
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogContent>
        <div style={{ textAlign: "center" }}>{isIcon}</div>
        <div style={{ textAlign: "center" }}>
          <Typography>{isTitle}</Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Donasi() {
  const { profil } = useData();
  const history = useHistory();
  const { id, idReference } = useParams();
  const { state } = useLocation();
  const classes = useStyles();

  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const [dialogAlert, setDialogAlert] = useState({ open: false, status: "" });

  const [popupKonfirmasi, setPopupKonfirmasi] = useState(false);

  const [loading, setLoading] = useState(false);

  const [loadingTransaksi, setLoadingTransaksi] = useState(false);
  const [transaksi, setTransaksi] = useState({
    total_saldo_kredit_available: 0,
  });

  const { total_saldo_kredit_available } = transaksi;

  const getTotalTransaksiSeller = useCallback(async () => {
    setLoadingTransaksi(true);
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });

    setTransaksi(res.data);
    setLoadingTransaksi(false);
  }, [profil.id]);
  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);

  // get riwayat donasi
  const [donationHistory, loadingDonationHistory, err] = useCollectionData(
    firestore
      .collection(`users/${profil.id}/donations`)
      .where("donation_id", "==", idReference)
      .orderBy("created_at", "desc"),
    { idField: "id" }
  );
  console.log("err", err);
  const nilai = [
    { label: "Rp 10.000", value: 10000 },
    { label: "Rp 20.000", value: 20000 },
    { label: "Rp 50.000", value: 50000 },
    { label: "Rp 100.000", value: 100000 },
    { label: "Rp 150.000", value: 150000 },
    { label: "Custom", value: "custom" },
  ];

  const validate = async () => {
    const newError = { ...error };
    if (!form?.amount) {
      newError.amount = "Nilai donasi harus di isi";
    }
    if (form?.amount == "0" || form?.amount == "") {
      newError.amount = "Nilai donasi harus di isi";
    }
    if (parseInt(form?.amount) > total_saldo_kredit_available) {
      newError.amount = "Komisi tidak cukup";
    }
    return newError;
  };

  const handleSubmit = async () => {
    const findError = await validate();
    if (Object.values(findError).some((m) => m !== "")) {
    } else {
      try {
        setLoading(true);
        setPopupKonfirmasi(false);
        const donasiFunc = firefunctions.httpsCallable("donation-submit");
        const res = await donasiFunc({
          donation_id: idReference,
          amount: parseInt(form.amount),
        });
        if (res.data) {
          setDialogAlert({
            open: true,
            status: res.data.success,
            data: state?.state ?? "",
          });
        }
        setLoading(false);
      } catch (e) {
        const newError = {};
        newError.title = e.message;

        setError(newError);
      }
    }
  };

  return (
    <>
      <Header
        type="with-title"
        title={`${state?.state?.nama ?? ""}`}
        onClick={() => history.goBack()}
      />
      <div className={classes.container}>
        <div className={classes.wrapHeader}>
          <Typography>Total Komisi Saya</Typography>
          {loadingTransaksi ? (
            <div style={{ justifyContent: "center", display: "flex" }}>
              <Skeleton width="20%" />
            </div>
          ) : (
            <Typography className={classes.liquidTitle}>
              {currency(total_saldo_kredit_available)}
            </Typography>
          )}
        </div>
        <div style={{ padding: 15 }}>
          <Grid container spacing={2}>
            {nilai?.map((item, index) => {
              return (
                <Grid item xs={4}>
                  <div
                    style={{
                      textAlign: "center",
                      color:form?.index == index && form?.value == item?.value
                      ? "#ffff"
                      : "#5675D3",
                      backgroundColor:
                        form?.index == index && form?.value == item?.value
                          ? "#5675D3"
                          : "#FFFF",
                      padding: 10,
                      borderRadius: 10,
                      cursor: "pointer",
                      border: "1px solid #5675D3",
                    }}
                    onClick={() =>
                      setForm({
                        index: index,
                        value: item.value,
                        amount: item?.value == "custom" ? "" : item?.value,
                      })
                    }
                  >
                    <Typography>{item?.label}</Typography>
                  </div>
                </Grid>
              );
            })}
            {form?.value == "custom" && (
              <Grid xs={12}>
                <div style={{ padding: 10 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={form?.amount}
                    error={error?.amount ? true : false}
                    onChange={(e) => {
                      const { value } = e.target;

                      setForm((item) => ({
                        ...item,
                        amount: value.replace(/[^\d]/g, ""),
                      }));
                    }}
                  />
                </div>
              </Grid>
            )}
          </Grid>
          <div style={{ padding: 15, marginBottom: 30 }}>
            <List
              subheader={
                <ListSubheader disableSticky={true}>
                  Riwayat {state?.state?.title}
                </ListSubheader>
              }
            >
              {loadingDonationHistory ? (
                "loading.."
              ) : donationHistory?.length > 0 ? (
                donationHistory?.map((item) => {
                  return (
                    <ListItem button>
                      <ListItemIcon>
                        {item?.status === "success" ? (
                          <CheckCircleIcon
                            style={{
                              color: item?.status === "success" && "#27AE60",
                            }}
                          />
                        ) : (
                          <CancelIcon color="error" />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography className={classes.liquid}>
                            {state?.state?.title} {item?.status}
                          </Typography>
                        }
                        secondary={
                          <div>
                            <Typography className={classes.liquidSecondList}>
                              {date(item?.created_at?.toDate?.())}
                            </Typography>
                          </div>
                        }
                      />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" size="small">
                          <Typography
                            className={classes.liquidThird}
                            style={{
                              color:
                                item?.status === "success"
                                  ? "#27AE60"
                                  : "#fa8e00",
                            }}
                          >
                            {currency(item?.amount)}
                          </Typography>
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    marginTop: "2.5%",
                  }}
                >
                  <Typography className={classes.liquidPrimary}>
                    Tidak Ada Data
                  </Typography>
                </div>
              )}
            </List>
          </div>
        </div>
        <div
          style={{
            padding: 15,
            position: "fixed",
            backgroundColor: "white",
            bottom: 0,
            maxWidth: "100%",
            width: "960px",
            left: "auto",
            right: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            disabled={loading || !form?.amount}
            onClick={() => setPopupKonfirmasi(true)}
          >
            {loading ? "Loading..." : state?.state?.title}
          </Button>
        </div>
      </div>
      <PopupKonfirmasi
        popupKonfirmasi={popupKonfirmasi}
        handleClose={() => setPopupKonfirmasi(false)}
        handleConfirm={handleSubmit}
        data={state?.state}
      />
      <DialogAlert
        open={dialogAlert.open}
        data={dialogAlert}
        handleClose={() => setDialogAlert({ open: false })}
      />
    </>
  );
}

export default Donasi;
